import DialogV2 from './src/main';
require('library-@/assets/styles/ui-default-theme/dialog-v2.scss');

/* istanbul ignore next */
DialogV2.install = function(Vue) {
    Vue.component(DialogV2.name, DialogV2);
};

export default DialogV2;
